import { Credentials } from './../../shared/models/my-account-data.models';
import { Contact, statusCodesEnum } from './../../shared/models/group-portal-data.models';
import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Observable, of, forkJoin, Subject, BehaviorSubject } from "rxjs";
import {
	HttpClient,
	HttpHeaders,
	HttpResponse,
	HttpErrorResponse
} from "@angular/common/http";
import {
	map,
	share,
	isEmpty,
	catchError,
	debounceTime,
	distinctUntilChanged,
	switchMap
} from "rxjs/operators";
import { Router } from "@angular/router";

import {
	GlobalDomOpsService,
	CommonOperationsService,
	GlobalDataOpsService,
	AcepSSOService
} from "@acepteam/globalspack";
import {
	DomService,
	DataService,
	HelperService,
	LoggerService
} from "../../core/services";
import { GroupPortalDomService } from "./group-portal-dom.service";
import { EmailHelperService } from "./email-helper.service";
import {
	Group,
	GroupInfo,
	HeaderInfo,
	AcepContact,
	MemberCounts,
	paymentMethod
} from "../../shared/models/group-portal-data.models";
import { DashboardPreferences } from "../../shared/models/common.data.models";
import { MyAccountDataOpsService } from "./my-account-dataops.service";

import { environment } from "../../../environments/environment";
import {
	AppUiData,
	GroupPortalData,
	MembershipDetails,
	EducationDetails,
	CRMMembership
} from "../../shared/models";
import { MapGroupPortalData, CheckIfInternational } from "../helpers/mapper";
import { MyAccountDetails } from "../../shared/models/my-account-data.models";
import { NotificationStatus } from "../../shared/enums/data.enums";
import { MembershipOrganization } from "../../shared/enums/xrm.constants";
import { OrgCode } from "@acepteam/payment";
import { FORMERR } from "dns";
import { each } from "jquery";
import { SideNavService } from '../components/side-nav/side-nav.service';

declare var $: any;
declare var moment: any;

@Injectable({
	providedIn: "root"
})
export class GroupPortalDataService {
	public memberAppData: GroupPortalData;
	public groupList: GroupInfo;
	public inGroupBilling: boolean;
	public masterOrder: any;
	public groupList$: Observable<void | GroupInfo>;
	public headerInfo: HeaderInfo = new HeaderInfo();
	public errorExist: boolean;
	public errorMessage: string;
	public showChart: boolean;
	public showGroupInfo = true;
	public specialty: string;
	public npiExists: boolean;
	public slideOutShown: boolean;
	public showPayMethods: boolean;
	public paymentMethodDoneProcessing: boolean;
	public groupInfoDoneProcessing: boolean;
	public invoicesDoneProcessing: boolean;
	public hideNavigation = false;
	public selectedContactDetails = new BehaviorSubject<AcepContact>(
		new AcepContact()
	);
	public newContact: any;
	public editResidencyInformation: Boolean = false;
	public editGroupSize: Boolean = false;
	public editGroupType: Boolean = false;
	public editManagementStyle: Boolean = false;
	public editProgramMedia: Boolean = false;
	public editSocialMedia: Boolean = false;
	public editProgramLeadership: Boolean = false;
	public editprogramLength: Boolean = false;
	public editNRMPNumber: Boolean = false;
	public editACGMEID: Boolean = false;
	public editAOAID: Boolean = false;
	public editpgy1PercentOffService: Boolean = false;
	public editavailableInternpositions: Boolean = false;
	public editTrainingOptions: Boolean = false;
	public editaccreditingBody: Boolean = false;
	public editprimaryTrainingSite: Boolean = false;
	public editsecondaryTrainingSite: Boolean = false;
	public editshiftLength: Boolean = false;
	public editshiftsPerMonth: Boolean = false;
	public editedVolume: Boolean = false;
	public editMonthDay: Boolean = false;
	public editapplicationsReceived: Boolean = false;
	public editstep1failures: Boolean = false;
	public editstep1cutoff: Boolean = false;
	public editpercentosteopath: Boolean = false;
	public editpercentimg: Boolean = false;
	public editmoonlighting: Boolean = false;
	public editelectiveweeks: Boolean = false;
	public editcriticalcaretraining: Boolean = false;
	public editmilitarybranch: Boolean = false;
	public editvisasponsorship: Boolean = false;
	public editsloesforinterview: Boolean = false;
	public editusmlecomlexpreferred: Boolean = false;
	public editprogramculture: Boolean = false;
	public selectedContactAddresses = new Subject<any[]>();
	public gpdsMemberCounts = new MemberCounts();
	public selectedGroup = new Subject<Group>();
	public groupNumber = new Subject<String>();
	public GroupInfo = new Subject<any>();
	public groupInvoices = new Subject<any[]>();
	public paymentTypes = new Subject<paymentMethod[]>();
	public allMembers = new Subject<any[]>();
	public ui_stateprovinces: any = [];
	private _myAccountData: MyAccountDetails;
	public dashboardPreferences: DashboardPreferences = new DashboardPreferences();
	public webapiurl = 'https://webapps.emra.org/utils/api/em/GetEMRegisterData?category=Residency';
	private wsBasePath = this.globalDataOpsService.WebServicesBasePath;
	public getGroupsURL =
		this.wsBasePath +
		"/aceptoolkit/api/2015/contactaccountauthorization";
	public getSelectedGroupUrl =
		this.wsBasePath +
		"/aceptoolkit/api/2019/account";
	public getGroupMembersURL =
		this.wsBasePath +
		"/aceptoolkit/api/2019/group/groupmembers";
	public getSearchContactListURL =
		this.wsBasePath +
		"/aceptoolkit/api/2019/contactsearch?";
	public putUpdateContactURL =
		this.wsBasePath +
		"/contactessentials/api/2019/UpdateContact";
	public getGroupInvoicesURL =
		this.wsBasePath +
		"/AcepOrder/api/2019/orders/getGroupInvoices/";
	public getGroupPaymentMethods =
		this.wsBasePath +
		"/AcepOrder/api/2019/orders/GetPaymentMethods";
	public getContactDetails =
		this.wsBasePath +
		"/aceptoolkit/api/2017/contactdetails/profile";
	public createContactURL =
		this.wsBasePath +
		"/contactessentials/api/2017/CreateContact";
	public calculateOrderURL =
		this.wsBasePath +
		"/AcepOrder/api/2019/orders/calculateorder";
	public recallOrApplyPaymentURL =
		this.wsBasePath +
		"/AcepOrder/api/2022/orders/groupbillpayment";
	public sortSubtotalAscending: boolean = false;
	public sortNameAscending: boolean = false;
	public sortNPIAscending: boolean = false;
	public sortStatusAscending: boolean = false;
	public sortInvoiceDateAscending: boolean = false;
	public sortGBNumberAscending: boolean = false;
	public sortInvoiceStatusAscending: boolean = false;
	public sortInvoiceAmountAscending: boolean = false;
	public sortedBy: string = "";
	public invoicesSortedBy: string = "";
	public chkAllMembers: boolean;
	public enableProcessPayment: boolean;
	public enableChkAllMembers: boolean;
	public emailExists: boolean;
	public purchaseOrderNo: string;
	public totalAmountCharged: string;

	//Local Storage keys
	private MEMBERSHIPDETAILS_KEY: string = "MEMBERSHIPDETAILS";
	private headers: HttpHeaders;

	//Paresh: Coding-2395
	public EMRAResRepText: String = 'EMRA Program Representative';
	public EMRAResAltRepText: String = 'EMRA Program Alternate Representative';
	//

	//Paresh: Coding-6060
	showLoader: boolean = false;

	public residency = {
		residencyId: '',
		specialityId: '',
		gradYear: '',
	}

	constructor(
		private ssoService: AcepSSOService,
		private globalDomOpsService: GlobalDomOpsService,
		private memberAppDomService: GroupPortalDomService,
		private domService: DomService,
		private globalDataOpsService: GlobalDataOpsService,
		private dataService: DataService,
		private myAccountDataService: MyAccountDataOpsService,
		private commonOpsService: CommonOperationsService,
		private helperService: HelperService,
		private titleService: Title,
		private loggerService: LoggerService,
		private emailHelperService: EmailHelperService,
		private sideNavService: SideNavService,
		private http: HttpClient,
		private router: Router
	) { }

	GetGroupPortalData(): Observable<GroupInfo> | Observable<any> | any {
		//console.log("data service calling MyAccount stats.");
		if (this.groupList.accountContacts.length > 0) {
			return of(this.groupList);
		}
		this.groupList$ = this.http
			.get(this.getGroupsURL + "?acepid=" + this.ssoService.acepid, {
				headers: new HttpHeaders({
					"Content-Type": "application/json",
					Authorization: this.ssoService.toolkitauthencoded
				})
			})
			.pipe(
				map((res: HttpResponse<any>) => {
					this.GetGroups(res);
				}),
				share()
			);

		return this.groupList$;
	}

	GetGroups(accountInfo) {
		if (accountInfo) {
			this.groupList.accountContacts = this.getEligibleGroups(
				accountInfo.accountContacts
			);
			if (
				!this.groupList.accountContacts ||
				(this.groupList.accountContacts.length !== 1 &&
					!this.groupList.groupNumber)
			) {
				this.groupList.groupNumber = null;
				this.groupList.slideOutType = "selectGroup";
				$("nav#sidebar").attr("style", "margin-left: 0px");
			} else {
				let accountId = this.groupList.groupNumber
					? this.groupList.groupNumber
					: this.groupList.accountContacts[0].acepId;
				$("ul li.active.route").removeClass("active route");
				$("ul li button#dashboard")
					.parent()
					.addClass("active route");
				this.slideOutBlur();
				this.SetSelectedGroup(accountId);
				this.SetGroupNumber(accountId);
				this.callGroupAPIs(true);
			}
		}
	}

	GetResidencyRegisterData() {
		// Initiates the AJAX call
		const myThis = this;
		const url = environment.ninjaapiendpoint + 'RunSproc?sp=ACEPsp_EMRAMatch_residencyUpdateProgram';
		this.http
			.get(url)
			.pipe(
				map((res: Response) => myThis.setResidencyRegisterData(res)),
				share()
			).subscribe();
	}

	setResidencyRegisterData(registerData) {
		this.groupList.RegisterData = registerData;
	}

	getEligibleGroups(accountContacts) {
		let groups = [];
		if (accountContacts) {
			for (var i = 0; i < accountContacts.length; i++) {
				let category = accountContacts[i]["accountCategory"];
				let role = accountContacts[i]["role"];
				if (
					(category.indexOf("Physician Group") !== -1 ||
						category.indexOf("Residency") !== -1) &&
					(role === "Group Administrator" ||
						role === "Group Administrator Staff")
				) {
					groups.push(accountContacts[i]);
				}
			}
			groups = groups.sort((a: any, b: any) =>
				a.accountName < b.accountName
					? -1
					: a.accountName > b.accountName
						? 1
						: 0
			);
			return groups;
		} else {
			return accountContacts;
		}
	}

	initializeGroupList() {
		this.groupList = new GroupInfo();
	}
	callGroupAPIs(newAccount: boolean) {
		this.errorExist = false;
		if (newAccount) {
			this.groupInfoDoneProcessing = false;
			this.invoicesDoneProcessing = false;
			this.showChart = false;
			this.paymentMethodDoneProcessing = false;
			this.groupList.allMembers = [];
			this.GetSelectedGroupInfo(this.groupList.groupNumber);
			this.sortedBy = "";
			this.getGroupInvoices();
		}
		this.GetResidencyRegisterData();
	}

	SetSlideOutType(type) {
		this.groupList.slideOutType = type;
	}
	SetSelectedGroup(accountId) {
		this.groupList.selectedGroup = this.findObjectByKey(
			this.groupList.accountContacts,
			"acepId",
			accountId
		);
	}

	SetGroupNumber(accountId) {
		this.groupList.groupNumber = accountId;
	}

	GetSelectedGroupInfo(accountId) {
		this.headerInfo = new HeaderInfo();
		this.showChart = false;
		this.setMemberCounts(new MemberCounts());
		return this.http
			.get(this.getSelectedGroupUrl + "/" + accountId, {
				headers: new HttpHeaders({
					"Content-Type": "application/json",
					Authorization: this.ssoService.toolkitauthencoded
				})
			})
			.pipe(
				map((res: HttpResponse<any>) => {
					this.sendGroupInfo(res);
					this.GetAllMembers(this.groupList.groupNumber);
					this.getPaymentMethods();
					this.initializeHeaderInfo(res);
				}),
				share()
			)
			.subscribe();
	}

	getPaymentMethods() {
		var adminContactNo = this.ssoService.acepid;
		var orgCode = this.groupList.GroupInfo.residencyDetail
			? 2
			: this.groupList.GroupInfo.physgrpDetail.sempaDuesPaid === "Yes"
				? 4
				: 1;

		return this.http
			.get(
				this.getGroupPaymentMethods +
				"?contactNo=" +
				adminContactNo +
				"&orgCode=" +
				orgCode,
				{
					headers: new HttpHeaders({
						"Content-Type": "application/json",
						Authorization: this.ssoService.toolkitauthencoded
					})
				}
			)
			.pipe(
				map((res: HttpResponse<any>) => {
					this.setPaymentMethods(res);
				}),
				share()
			)
			.subscribe();
	}
	// SearchEmail(searchterms: Observable<string>): any {
	// 	return searchterms.pipe(debounceTime(500),
	// 		distinctUntilChanged(), switchMap(term => this.userExistsByEmail(term, this.selectedContactDetails.value.ACEPID)));
	// }
	GetAllMembers(accountId) {
		return this.http
			.get(this.getGroupMembersURL + "/" + accountId, {
				headers: new HttpHeaders({
					"x-silent": "true",
					"Content-Type": "application/json",
					Authorization: this.ssoService.toolkitauthencoded
				})
			})
			.pipe(
				map((res: HttpResponse<any>) => {
					this.getOrderInformation(res);
				}),
				catchError((error: HttpErrorResponse) => {
					let observError = new Subject<any>();
					console.log(error.error);
					this.errorExist = true;
					this.errorMessage = error.error;
					observError.next(error);
					return observError;
				}),
				share()
			)
			.subscribe();
	}

	//pga: Feature-2920 Recall or Apply Payment API call
	recallOrApplyPayment(accountId, isRecall) {
		this.showLoader = true;
		let payload = {
			AccountNo: accountId,
			Action: isRecall ? 'Recall' : 'Process'
		}

		return this.http
			.post(this.recallOrApplyPaymentURL, JSON.stringify(payload), {
				headers: new HttpHeaders({
					"x-silent": "true",
					"Content-Type": "application/json",
					Authorization: this.ssoService.toolkitauthencoded
				}),
				observe: "response",
			})
			.pipe(
				map((res: HttpResponse<any>) => {
					this.showLoader = false;
					if (!isRecall) {
						this.purchaseOrderNo = res.headers.get("purchaseOrderNo");
						this.totalAmountCharged = res.headers.get("totalAmountCharged");
						this.hideNavigation = true;
					} else {
						window.location.reload();
					}
				}),
				catchError((error: HttpErrorResponse) => {
					this.showLoader = false;
					let observError = new Subject<any>();
					console.log(error.error);
					this.errorExist = true;
					this.errorMessage = error.error;
					observError.next(error);
					return observError;
				}),
				share()
			)
			.subscribe();
	}

	getOrderInformation(members, add = false, edit = false) {
		var orgCode = this.groupList.GroupInfo.residencyDetail
			? 2
			: this.groupList.GroupInfo.physgrpDetail.sempaDuesPaid === "Yes"
				? 4
				: 1;
		let myThis = this;
		let payload = {
			OrderTypeCode: "MembershipGroup",
			GroupOrder: {
				AccountNo: this.groupList.groupNumber,
				AdminContactNo: "",
				OrgCode: orgCode,
				IncludeCancelledMembers: "true",
				PriceLevelName: "MEMBERSHIP",
				IndividualOrders: add ? this.setIndividualOrders(members) : []
			}
		};
		return this.http
			.post(this.calculateOrderURL, JSON.stringify(payload), {
				headers: new HttpHeaders({
					"x-silent": "true",
					"Content-Type": "application/json",
					Authorization: this.ssoService.toolkitauthencoded
				})
			})
			.pipe(
				map((res: Response) => {
					myThis.checkDueDate(res);
					!add
						? this.setGroupListAllMembers(members, res)
						: this.addNewGroupMemberToList(members, edit, res);
				}),
				catchError((error: HttpErrorResponse) => {
					this.showChart = true;
					let observError = new Subject<any>();
					console.log(error.error);
					this.errorExist = true;
					this.errorMessage = error.error;
					observError.next(error);
					return observError;
				}),
				share()
			)
			.subscribe();
	}

	checkDueDate(calcOrderResponse) {
		let dueDate = this.groupList.GroupInfo.residencyDetail && this.groupList.GroupInfo.residencyDetail.dueDate
			? this.groupList.GroupInfo.residencyDetail.dueDate
			: this.groupList.GroupInfo.physgrpDetail
				? this.groupList.GroupInfo.physgrpDetail.dueDate
				: "";

		this.headerInfo.dueDate = this.SantizeDate(dueDate.toString()) === this.SantizeDate(calcOrderResponse.groupOrder.termStartDate.toString()) ? this.headerInfo.dueDate : this.SantizeDate(calcOrderResponse.groupOrder.termStartDate.toString());
	}

	setIndividualOrders(members) {
		let io = [];

		for (var i = 0; i < members.length; i++) {
			let individual: any;

			individual = {
				IndividualNo: members[i].contactNo,
				CustomerType: "Contact"
			};

			io.push(individual);
		}
		return io;
	}
	GetAddedMember(contactId, edit = false) {
		return this.http
			.get(
				this.getGroupMembersURL +
				"/" +
				this.groupList.groupNumber +
				"/contacts/" +
				contactId,
				{
					headers: new HttpHeaders({
						"Content-Type": "application/json",
						Authorization: this.ssoService.toolkitauthencoded
					})
				}
			)
			.pipe(
				map((res: HttpResponse<any>) => {
					this.checkStatusToSendEmail_ForGroupMemberAddition(res);
					this.getOrderInformation(res, true, edit);
				}),
				share()
			)
			.subscribe();
	}


	GetContactDetailsById(contactId) {
		return this.http
			.get(
				this.getGroupsURL.replace('contactaccountauthorization', 'contactdetailsbyid') +
				"?acepid=" + contactId,
				{
					headers: new HttpHeaders({
						"Content-Type": "application/json",
						Authorization: this.ssoService.toolkitauthencoded
					})
				}
			)

	}


	checkStatusToSendEmail_ForGroupMemberAddition(member) {
		if (member[0].status == this.statusCodeEnum.Pending) {
			var isSempa = this.groupList.GroupInfo.physgrpDetail
				? this.groupList.GroupInfo.physgrpDetail.sempaDuesPaid == "Yes"
				: false;

			this.getContactInfoAndSendEmail(member[0].contactNo, isSempa);		
		}
	}

	getGroupInvoices() {
		return this.http
			.get(this.getGroupInvoicesURL + this.groupList.groupNumber, {
				headers: new HttpHeaders({
					"x-silent": "true",
					"Content-Type": "application/json",
					Authorization: this.ssoService.toolkitauthencoded
				})
			})
			.pipe(
				map((res: HttpResponse<any>) => {
					this.setGroupInvoices(res);
				}),
				share()
			)
			.subscribe();
	}

	setGroupInvoices(invoices) {
		this.invoicesSortedBy = "date";
		this.sortInvoiceDateAscending = false;
		this.groupList.groupInvoices = invoices;
		//pga: Feature-2920 setting property to check submitted status
		this.groupList.hasSubmittedStatus = this.hasSubmittedStstus;
		this.changeSortInvoiceDate();
		this.invoicesDoneProcessing = true;
	}

	ResendInviteEmail(accountId) {
		//Ask Christian or Mohan about this
	}

	CreateContact(contact: AcepContact, leadershipOnly = false) {
		var selectedContact = new AcepContact();
		selectedContact = contact;
		selectedContact.prefix = this.findCountryIndex(
			this.dataService.uidata.Prefix,
			"label",
			contact.prefix
		);
		let payload = this.createContactPayload(selectedContact);

		return this.http
			.post(this.createContactURL, JSON.stringify(payload), {
				headers: new HttpHeaders({
					"Content-Type": "application/json",
					Authorization: this.ssoService.toolkitauthencoded
				})
			})
			.pipe(
				map((res: Response) => {
					if (!leadershipOnly) {
						this.addMemberToGroup(contact, res);
					} else {
						this.setAddedLeadershipContact(contact, res);
						this.slideOutBlur();
					}
				}),
				share()
			)
			.subscribe();
	}

	createContactPayload(contact: AcepContact) {
		let payload = [contact];

		return payload;
	}

	addMemberToGroup(contact: AcepContact, contactResponse = null) {
		let payload = [
			{
				contactNo: contactResponse
					? contactResponse[0].acepid
					: contact.ACEPID,
				beginDate: contact.startDate,
				endDate: contact.endDate,
				isInGroupBilling: contact.groupBilling,
				primaryChapter: contact.Chapter,
				residencyId: contact.residency.id,
				residencySpecialtyId: contact.residency.specialityId,
				gradYear: contact.residency.gradYear
			}
		];

		return this.http
			.post(
				this.getGroupMembersURL + "/" + this.groupList.groupNumber,
				JSON.stringify(payload),
				{
					headers: new HttpHeaders({
						"Content-Type": "application/json",
						Authorization: this.ssoService.toolkitauthencoded
					})
				}
			)
			.pipe(
				map((res: HttpResponse<any>) => {
					if (contactResponse) {
						this.GetAddedMember(
							contactResponse
								? contactResponse[0].acepid
								: contact.ACEPID
						);
						contact.showSuccessMsg = true;
						this.setEditContactInfo(contact);
					} else {
						this.updateContact(contact, true, false);
					}
				}),
				share()
			)
			.subscribe();
	}

	RemoveContact(contactId) {
		return this.http
			.delete(
				this.getGroupMembersURL +
				"/" +
				this.headerInfo.groupId +
				"/contacts/" +
				contactId,
				{
					headers: new HttpHeaders({
						"Content-Type": "application/json",
						Authorization: this.ssoService.toolkitauthencoded
					})
				}
			)
			.pipe(
				map((res: HttpResponse<any>) => {
					this.removeMemberfromGroup(contactId);
				}),
				share()
			)
			.subscribe();
	}

	updateContact(contact: AcepContact, newToGroup = false, edit = true) {
		var selectedContact = new AcepContact();
		selectedContact = contact;
		selectedContact.prefix = this.findCountryIndex(
			this.dataService.uidata.Prefix,
			"label",
			contact.prefix
		);

		//json.stringify resets the deep nested props sometiems when passed as reference objects.. 
		//Create a deep cloned object so the object stays pure MB 1/23/2024

		let contact_deepcloned = JSON.parse(JSON.stringify(contact));


		return this.http
			.put(this.putUpdateContactURL, JSON.stringify(selectedContact), {
				headers: new HttpHeaders({
					"Content-Type": "application/json",
					Authorization: this.ssoService.toolkitauthencoded
				})
			})
			.pipe(
				map((res: HttpResponse<any>) => {
					this.updateGroupMember(contact_deepcloned, newToGroup, edit);
				}),
				share()
			)
			.subscribe();
	}

	refreshStateProvinces() {
		//debugger;
		this.ui_stateprovinces = [];
		if (this.dataService.uidata) {
			this.dataService.uidata.StateProvinces.forEach(state => {
				const selectedCountry = this.groupList.FormGroupInfo ? this.groupList.FormGroupInfo.country : "US";
				if (state.countrycode === selectedCountry) {
					this.ui_stateprovinces.push(state);
				}
			});
			// this.ui_stateprovinces = this.dataService.uidata.StateProvinces.filter(
			// 	(s) =>
			// 		s.countrycode ===
			// 		this.groupList.FormGroupInfo
			// 			? this.groupList.FormGroupInfo.country
			// 			: "US"
			// );
		}
		if (
			this.groupList.FormGroupInfo &&
			(!this.groupList.FormGroupInfo.state || this.ui_stateprovinces < 1 ||
				this.findObjectByKey(
					this.ui_stateprovinces,
					"acep_isocode",
					this.groupList.FormGroupInfo.state
				).length < 1)
		) {
			this.groupList.FormGroupInfo.state = "";
		}
	}

	updateGroupInformation() {

		return this.http.put(this.getSelectedGroupUrl + "/" + this.groupList.groupNumber, this.groupList.GroupInfo, {
			headers: new HttpHeaders({
				"Content-Type": "application/json",
				Authorization: this.ssoService.toolkitauthencoded
			})
		}).pipe(
			map((res: HttpResponse<any>) => {
				// any coded
				this.showGroupInfo = true;
				if (this.groupList.GroupInfo && this.groupList.GroupInfo.residencyDetail) {
					this.setSpecialty();
				}
				this.setAreasToShow();
				this.sendNewLeadershipEmails();
			}),
			share()
		)
			.subscribe();
	}

	sendNewLeadershipEmails() {
		this.groupList.GroupInfo.groupContacts.forEach(contact => {
			if (contact.newLeadership && contact.position === "Group Administrator") {
				this.emailHelperService.sendGroupAdminInviteEmail(contact, this.headerInfo.groupName);
			}
			//Paresh: Coding-1860 Send email to new EMRA contact
			else if (contact.newLeadership && (contact.position === this.EMRAResRepText || contact.position === this.EMRAResAltRepText)) {
				this.emailHelperService.sendEMRANewContactsEmail(contact);
			}
			//
		});
	}

	setNewContact() {
		const today = new Date();
		this.newContact = {
			formalName: '',
			email: '',
			position: this.groupList.GroupInfo.physgrpDetail ? 'Group Administrator' : '',
			beginDate: today,
			endDate: '',
			contactNo: null,
			newLeadership: true
		};
		//this.checkLeadershipAmounts();
	}

	setAddedLeadershipContact(contact: AcepContact, contactResponse = null) {
		const today = new Date();
		this.newContact = {
			formalName: contactResponse[0].firstName + ' ' + contactResponse[0].lastName,
			email: contact.EmailAddress,
			position: this.newContact.position,
			beginDate: today,
			endDate: '',
			contactNo: this.emailExists ? contactResponse[0].acepId : contactResponse[0].acepid,
			newLeadership: true
		};
		//this.checkLeadershipAmounts();

	}

	toggleSection(sectionName) {
		switch (sectionName) {
			case "editResidencyInformation": {

				if (this.editResidencyInformation) {
					this.groupList.FormGroupInfo.attention = this.groupList.GroupInfo.attention;
					this.groupList.FormGroupInfo.street = this.groupList.GroupInfo.street;
					this.groupList.FormGroupInfo.apt = this.groupList.GroupInfo.apt;
					this.groupList.FormGroupInfo.city = this.groupList.GroupInfo.city;
					this.groupList.FormGroupInfo.country = this.groupList.GroupInfo.country;
					this.groupList.FormGroupInfo.state = this.groupList.GroupInfo.state;
					this.groupList.FormGroupInfo.zip = this.groupList.GroupInfo.zip;
				}
				this.editResidencyInformation = this.editResidencyInformation ? false : true;
				break;
			}
			case "editProgramMedia": {
				if (this.editProgramMedia) {
					this.groupList.FormGroupInfo.webSite = this.groupList.GroupInfo.webSite;
					//this.groupList.FormGroupInfo.twitter = this.groupList.GroupInfo.twitter;
					//this.groupList.FormGroupInfo.facebook = this.groupList.GroupInfo.facebook;
					//this.groupList.FormGroupInfo.instagram = this.groupList.GroupInfo.instagram;
					//this.groupList.FormGroupInfo.youtube = this.groupList.GroupInfo.youtube;
					//this.groupList.FormGroupInfo.vimeo = this.groupList.GroupInfo.vimeo;
					this.groupList.FormGroupInfo.multiMedia = this.groupList.GroupInfo.multiMedia;
					this.groupList.FormGroupInfo.multiMedia2 = this.groupList.GroupInfo.multiMedia2;
					this.groupList.FormGroupInfo.multiMedia3 = this.groupList.GroupInfo.multiMedia3;
				}
				this.editProgramMedia = this.editProgramMedia ? false : true;
				break;
			}
			case "editSocialMedia": {
				if (this.editSocialMedia) {
					//this.groupList.FormGroupInfo.webSite = this.groupList.GroupInfo.webSite;
					this.groupList.FormGroupInfo.twitter = this.groupList.GroupInfo.twitter;
					this.groupList.FormGroupInfo.facebook = this.groupList.GroupInfo.facebook;
					this.groupList.FormGroupInfo.instagram = this.groupList.GroupInfo.instagram;
					this.groupList.FormGroupInfo.youtube = this.groupList.GroupInfo.youtube;
					this.groupList.FormGroupInfo.vimeo = this.groupList.GroupInfo.vimeo;
					//this.groupList.FormGroupInfo.multiMedia = this.groupList.GroupInfo.multiMedia;
					//this.groupList.FormGroupInfo.multiMedia2 = this.groupList.GroupInfo.multiMedia2;
					//this.groupList.FormGroupInfo.multiMedia3 = this.groupList.GroupInfo.multiMedia3;
				}
				this.editSocialMedia = this.editSocialMedia ? false : true;
				break;
			}
			case "editProgramLeadership": {
				if (this.editProgramLeadership) {
					this.setNewContact();
					this.groupList.FormGroupInfo.groupContacts = this.groupList.GroupInfo.groupContacts;
				}
				this.editProgramLeadership = this.editProgramLeadership ? false : true;
				break;
			}
			case "editprogramLength": {
				if (this.editprogramLength) {
					this.groupList.FormGroupInfo.residencyDetail.programLength = this.groupList.GroupInfo.residencyDetail.programLength;
				}
				this.editprogramLength = this.editprogramLength ? false : true;
				break;
			}
			case "editNRMPNumber": {
				if (this.editNRMPNumber) {
					this.groupList.FormGroupInfo.residencyDetail.nrmpCode = this.groupList.GroupInfo.residencyDetail.nrmpCode;
				}
				this.editNRMPNumber = this.editNRMPNumber ? false : true;
				break;
			}
			case "editACGMEID": {
				if (this.editACGMEID) {
					this.groupList.FormGroupInfo.residencyDetail.acgmeId = this.groupList.GroupInfo.residencyDetail.acgmeId;
				}
				this.editACGMEID = this.editACGMEID ? false : true;
				break;
			}
			case "editAOAID": {
				if (this.editAOAID) {
					this.groupList.FormGroupInfo.residencyDetail.aoaId = this.groupList.GroupInfo.residencyDetail.aoaId;
				}
				this.editAOAID = this.editAOAID ? false : true;
				break;
			}
			case "editpgy1PercentOffService": {
				if (this.editpgy1PercentOffService) {
					this.groupList.FormGroupInfo.residencyDetail.pgy1PercentOffService = this.groupList.GroupInfo.residencyDetail.pgy1PercentOffService;
				}
				this.editpgy1PercentOffService = this.editpgy1PercentOffService ? false : true;
				break;
			}
			case "editavailableInternpositions": {
				if (this.editavailableInternpositions) {
					this.groupList.FormGroupInfo.residencyDetail.availableInternpositions = this.groupList.GroupInfo.residencyDetail.availableInternpositions;
				}
				this.editavailableInternpositions = this.editavailableInternpositions ? false : true;
				break;
			}
			case "editTrainingOptions": {
				if (this.editTrainingOptions) {
					this.groupList.FormGroupInfo.residencyDetail.isSpecialtyEM = this.groupList.GroupInfo.residencyDetail.isSpecialtyEM;
					this.groupList.FormGroupInfo.residencyDetail.isSpecialtyFM = this.groupList.GroupInfo.residencyDetail.isSpecialtyFM;
					this.groupList.FormGroupInfo.residencyDetail.isSpecialtyIM = this.groupList.GroupInfo.residencyDetail.isSpecialtyIM;
					this.groupList.FormGroupInfo.residencyDetail.isSpecialtyCC = this.groupList.GroupInfo.residencyDetail.isSpecialtyCC;
					this.groupList.FormGroupInfo.residencyDetail.isSpecialtyAnesthesia = this.groupList.GroupInfo.residencyDetail.isSpecialtyAnesthesia;
					this.groupList.FormGroupInfo.residencyDetail.isSpecialtyPD = this.groupList.GroupInfo.residencyDetail.isSpecialtyPD;
				}
				this.editTrainingOptions = this.editTrainingOptions ? false : true;
				break;
			}
			case "editGroupSize": {
				if (this.editGroupSize) {
					this.groupList.FormGroupInfo.physgrpDetail.size = this.groupList.GroupInfo.physgrpDetail.size;
				}
				this.editGroupSize = this.editGroupSize
					? false
					: true;
				break;
			}
			case "editGroupType": {
				if (this.editGroupType) {
					this.groupList.FormGroupInfo.physgrpDetail.type = this.groupList.GroupInfo.physgrpDetail.type;
				}
				this.editGroupType = this.editGroupType
					? false
					: true;
				break;
			}
			case "editManagementStyle": {
				if (this.editManagementStyle) {
					this.groupList.FormGroupInfo.physgrpDetail.managementStyle = this.groupList.GroupInfo.physgrpDetail.managementStyle;
				}
				this.editManagementStyle = this.editManagementStyle
					? false
					: true;
				break;
			}

			case "editaccreditingBody": {
				if (this.editaccreditingBody) {
					this.groupList.FormGroupInfo.residencyDetail.accreditingBody = this.groupList.GroupInfo.residencyDetail.accreditingBody;
				}
				this.editaccreditingBody = this.editaccreditingBody
					? false
					: true;
				break;
			}
			case "editprimaryTrainingSite": {
				if (this.editprimaryTrainingSite) {
					this.groupList.FormGroupInfo.residencyDetail.primaryTrainingSite = this.groupList.GroupInfo.residencyDetail.primaryTrainingSite;
				}
				this.editprimaryTrainingSite = this.editprimaryTrainingSite
					? false
					: true;
				break;
			}
			case "editsecondaryTrainingSite": {
				if (this.editsecondaryTrainingSite) {
					this.groupList.FormGroupInfo.residencyDetail.secondaryTrainingSite = this.groupList.GroupInfo.residencyDetail.secondaryTrainingSite;
				}
				this.editsecondaryTrainingSite = this.editsecondaryTrainingSite
					? false
					: true;
				break;
			}
			case "editshiftLength": {
				if (this.editshiftLength) {
					this.groupList.FormGroupInfo.residencyDetail.shiftLength = this.groupList.GroupInfo.residencyDetail.shiftLength;
				}
				this.editshiftLength = this.editshiftLength ? false : true;
				break;
			}
			case "editshiftsPerMonth": {
				if (this.editshiftsPerMonth) {
					this.groupList.FormGroupInfo.residencyDetail.shiftsPerMonth = this.groupList.GroupInfo.residencyDetail.shiftsPerMonth;
				}
				this.editshiftsPerMonth = this.editshiftsPerMonth
					? false
					: true;
				break;
			}
			case "editedVolume": {
				if (this.editedVolume) {
					this.groupList.FormGroupInfo.residencyDetail.edVolume = this.groupList.GroupInfo.residencyDetail.edVolume;
				}
				this.editedVolume = this.editedVolume ? false : true;
				break;
			}
			case "editMonthDay": {
				if (this.editMonthDay) {
					this.groupList.FormGroupInfo.residencyDetail.month = this.groupList.GroupInfo.residencyDetail.month;
					this.groupList.FormGroupInfo.residencyDetail.day = this.groupList.GroupInfo.residencyDetail.day;
				}
				this.editMonthDay = this.editMonthDay ? false : true;
				break;
			}
			case "editapplicationsReceived": {
				if (this.editapplicationsReceived) {
					this.groupList.FormGroupInfo.residencyDetail.applicationsReceived = this.groupList.GroupInfo.residencyDetail.applicationsReceived;
				}
				this.editapplicationsReceived = this.editapplicationsReceived
					? false
					: true;
				break;
			}
			case "editstep1failures": {
				if (this.editstep1failures) {
					this.groupList.FormGroupInfo.residencyDetail.step1Failures = this.groupList.GroupInfo.residencyDetail.step1Failures;
				}
				this.editstep1failures = this.editstep1failures ? false : true;
				break;
			}
			case "editstep1cutoff": {
				if (this.editstep1cutoff) {
					this.groupList.FormGroupInfo.residencyDetail.step1Cutoff = this.groupList.GroupInfo.residencyDetail.step1Cutoff;
				}
				this.editstep1cutoff = this.editstep1cutoff ? false : true;
				break;
			}
			case "editpercentosteopath": {
				if (this.editpercentosteopath) {
					this.groupList.FormGroupInfo.residencyDetail.percentOsteopath = this.groupList.GroupInfo.residencyDetail.percentOsteopath;
				}
				this.editpercentosteopath = this.editpercentosteopath
					? false
					: true;
				break;
			}
			case "editpercentimg": {
				if (this.editpercentimg) {
					this.groupList.FormGroupInfo.residencyDetail.percentImg = this.groupList.GroupInfo.residencyDetail.percentImg;
				}
				this.editpercentimg = this.editpercentimg ? false : true;
				break;
			}
			case "editmoonlighting": {
				if (this.editmoonlighting) {
					this.groupList.FormGroupInfo.residencyDetail.moonlighting = this.groupList.GroupInfo.residencyDetail.moonlighting;
				}
				this.editmoonlighting = this.editmoonlighting ? false : true;
				break;
			}
			case "editelectiveweeks": {
				if (this.editelectiveweeks) {
					this.groupList.FormGroupInfo.residencyDetail.electiveWeeks = this.groupList.GroupInfo.residencyDetail.electiveWeeks;
				}
				this.editelectiveweeks = this.editelectiveweeks ? false : true;
				break;
			}
			case "editcriticalcaretraining": {
				if (this.editcriticalcaretraining) {
					this.groupList.FormGroupInfo.residencyDetail.criticalCareTraining = this.groupList.GroupInfo.residencyDetail.criticalCareTraining;
				}
				this.editcriticalcaretraining = this.editcriticalcaretraining
					? false
					: true;
				break;
			}
			case "editmilitarybranch": {
				if (this.editmilitarybranch) {
					this.groupList.FormGroupInfo.residencyDetail.militaryBranch = this.groupList.GroupInfo.residencyDetail.militaryBranch;
				}
				this.editmilitarybranch = this.editmilitarybranch
					? false
					: true;
				break;
			}
			case "editvisasponsorship": {
				if (this.editvisasponsorship) {
					this.groupList.FormGroupInfo.residencyDetail.visaSponsorship = this.groupList.GroupInfo.residencyDetail.visaSponsorship;
				}
				this.editvisasponsorship = this.editvisasponsorship
					? false
					: true;
				break;
			}
			case "editsloesforinterview": {
				if (this.editsloesforinterview) {
					this.groupList.FormGroupInfo.residencyDetail.sloesForInterview = this.groupList.GroupInfo.residencyDetail.sloesForInterview;
				}
				this.editsloesforinterview = this.editsloesforinterview
					? false
					: true;
				break;
			}
			case "editusmlecomlexpreferred": {
				if (this.editusmlecomlexpreferred) {
					this.groupList.FormGroupInfo.residencyDetail.usmleComplexPreference = this.groupList.GroupInfo.residencyDetail.usmleComplexPreference;
				}
				this.editusmlecomlexpreferred = this.editusmlecomlexpreferred
					? false
					: true;
				break;
			}
			case "editprogramculture": {
				if (this.editprogramculture) {
					this.groupList.FormGroupInfo.residencyDetail.programCulture = this.groupList.GroupInfo.residencyDetail.programCulture;
				}
				this.editprogramculture = this.editprogramculture
					? false
					: true;
				break;
			}
			default: {
				break;
			}
		}
	}

	setAreasToShow() {
		if (this.groupList.GroupInfo.street === null || this.groupList.GroupInfo.street === ''
			|| this.groupList.GroupInfo.city === null || this.groupList.GroupInfo.city === ''
			|| this.groupList.GroupInfo.country === null || this.groupList.GroupInfo.country === ''
			|| this.groupList.GroupInfo.state === null || this.groupList.GroupInfo.state === ''
			|| this.groupList.GroupInfo.zip === null || this.groupList.GroupInfo.zip === '') {
			this.editResidencyInformation = true;
		} else {
			this.editResidencyInformation = false;
		}
		if (this.groupList.GroupInfo.webSite === null &&
			//this.groupList.GroupInfo.twitter === null &&
			//this.groupList.GroupInfo.facebook === null &&
			//this.groupList.GroupInfo.instagram === null &&
			//this.groupList.GroupInfo.youtube === null &&
			//this.groupList.GroupInfo.vimeo === null &&
			this.groupList.GroupInfo.multiMedia === null &&
			this.groupList.GroupInfo.multiMedia2 === null &&
			this.groupList.GroupInfo.multiMedia3 === null) {
			this.editProgramMedia = true;
		} else {
			this.editProgramMedia = false;
		}
		if (//this.groupList.GroupInfo.webSite === null &&
			this.groupList.GroupInfo.twitter === null &&
			this.groupList.GroupInfo.facebook === null &&
			this.groupList.GroupInfo.instagram === null &&
			this.groupList.GroupInfo.youtube === null &&
			this.groupList.GroupInfo.vimeo === null
			//this.groupList.GroupInfo.multiMedia === null &&
			//this.groupList.GroupInfo.multiMedia2 === null &&
			//this.groupList.GroupInfo.multiMedia3 === null
		) {
			this.editSocialMedia = true;
		} else {
			this.editSocialMedia = false;
		}
		// if (this.groupList.GroupInfo.webSite === null) {
		// 	this.editProgramLeadership = true;
		// }
		if (this.groupList.GroupInfo.residencyDetail) {
			if (this.groupList.GroupInfo.residencyDetail.programLength === null) {
				this.editprogramLength = true;
			} else {
				this.editprogramLength = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.nrmpCode === null) {
				this.editNRMPNumber = true;
			} else {
				this.editNRMPNumber = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.acgmeId === null) {
				this.editACGMEID = true;
			} else {
				this.editACGMEID = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.aoaId === null) {
				this.editAOAID = true;
			} else {
				this.editAOAID = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.availableInternpositions === null) {
				this.editavailableInternpositions = true;
			} else {
				this.editavailableInternpositions = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.pgy1PercentOffService === null) {
				this.editpgy1PercentOffService = true;
			} else {
				this.editpgy1PercentOffService = false;
			}
			if (!this.groupList.GroupInfo.residencyDetail.isSpecialtyEM &&
				!this.groupList.GroupInfo.residencyDetail.isSpecialtyFM &&
				!this.groupList.GroupInfo.residencyDetail.isSpecialtyIM &&
				!this.groupList.GroupInfo.residencyDetail.isSpecialtyCC &&
				!this.groupList.GroupInfo.residencyDetail.isSpecialtyAnesthesia &&
				!this.groupList.GroupInfo.residencyDetail.isSpecialtyPD) {
				this.editTrainingOptions = true;
			} else {
				this.editTrainingOptions = false;
			}

			if (this.groupList.GroupInfo.residencyDetail.accreditingBody === null) {
				this.editaccreditingBody = true;
			} else {
				this.editaccreditingBody = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.primaryTrainingSite === null) {
				this.editprimaryTrainingSite = true;
			} else {
				this.editprimaryTrainingSite = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.secondaryTrainingSite === null) {
				this.editsecondaryTrainingSite = true;
			} else {
				this.editsecondaryTrainingSite = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.shiftLength === null) {
				this.editshiftLength = true;
			} else {
				this.editshiftLength = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.shiftsPerMonth === null) {
				this.editshiftsPerMonth = true;
			} else {
				this.editshiftsPerMonth = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.edVolume === null) {
				this.editedVolume = true;
			} else {
				this.editedVolume = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.month === null && this.groupList.GroupInfo.residencyDetail.day === null) {
				this.editMonthDay = true;
			} else {
				this.editMonthDay = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.applicationsReceived === null) {
				this.editapplicationsReceived = true;
			} else {
				this.editapplicationsReceived = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.step1Failures === null) {
				this.editstep1failures = true;
			} else {
				this.editstep1failures = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.step1Cutoff === null) {
				this.editstep1cutoff = true;
			} else {
				this.editstep1cutoff = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.percentOsteopath === null) {
				this.editpercentosteopath = true;
			} else {
				this.editpercentosteopath = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.percentImg === null) {
				this.editpercentimg = true;
			} else {
				this.editpercentimg = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.moonlighting === null) {
				this.editmoonlighting = true;
			} else {
				this.editmoonlighting = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.electiveWeeks === null) {
				this.editelectiveweeks = true;
			} else {
				this.editelectiveweeks = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.criticalCareTraining === null) {
				this.editcriticalcaretraining = true;
			} else {
				this.editcriticalcaretraining = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.militaryBranch === null) {
				this.editmilitarybranch = true;
			} else {
				this.editmilitarybranch = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.visaSponsorship === null) {
				this.editvisasponsorship = true;
			} else {
				this.editvisasponsorship = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.sloesForInterview === null) {
				this.editsloesforinterview = true;
			} else {
				this.editsloesforinterview = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.usmleComplexPreference === null) {
				this.editusmlecomlexpreferred = true;
			} else {
				this.editusmlecomlexpreferred = false;
			}
			if (this.groupList.GroupInfo.residencyDetail.programCulture === null) {
				this.editprogramculture = true;
			} else {
				this.editprogramculture = false;
			}
		} else {
			if (this.groupList.GroupInfo.physgrpDetail.size === null) {
				this.editGroupSize = true;
			} else {
				this.editGroupSize = false;
			}
			if (this.groupList.GroupInfo.physgrpDetail.type === null) {
				this.editGroupType = true;
			} else {
				this.editGroupType = false;
			}
			if (this.groupList.GroupInfo.physgrpDetail.managementStyle === null) {
				this.editManagementStyle = true;
			} else {
				this.editManagementStyle = false;
			}
		}
	}

	updateGroupMember(contact: AcepContact, newToGroup = false, edit = true) {
		let payload = [
			{
				contactNo: contact.ACEPID,
				beginDate: contact.startDate,
				endDate: contact.endDate,
				isInGroupBilling: contact.groupBilling,
				primaryChapter: contact.Chapter,
				residencyId: contact.residency.id,
				residencySpecialtyId: contact.residency.specialityId,
				gradYear: contact.residency.gradYear
			}
		];

		return this.http
			.put(
				this.getGroupMembersURL + "/" + this.groupList.groupNumber,
				JSON.stringify(payload),
				{
					headers: new HttpHeaders({
						"Content-Type": "application/json",
						Authorization: this.ssoService.toolkitauthencoded
					})
				}
			)
			.pipe(
				map((res: HttpResponse<any>) => {
					this.GetAddedMember(contact.ACEPID, edit);
					if (newToGroup) {
						contact.showSuccessMsg = true;
						this.setEditContactInfo(contact);
					}
				}),
				share()
			)
			.subscribe();
	}

	removeMemberfromGroup(contactId) {
		//remove member from groupList.allmembers
		let newMemberList = [];
		let array = this.groupList.allMembers;

		for (var i = 0; i < array.length; i++) {
			if (array[i]["contactNo"] !== contactId) {
				newMemberList.push(array[i]);
			}
		}
		this.groupList.allMembers = newMemberList;
		this.headerInfo.members = newMemberList.length;
		this.calculateMemberCounts(newMemberList);
		this.getHeaderAmountDue();
	}

	addNewGroupMemberToList(Member, edit = false, orderInformation) {
		let indOrders = this.masterOrder.groupOrder.individualOrders;
		if (edit) {
			this.removeMemberfromGroup(Member[0].contactNo);
		} else {
			for (var i = 0; i < orderInformation.groupOrder.individualOrders.length; i++) {
				indOrders.push(orderInformation.groupOrder.individualOrders[i]);
			}
		}
		let newMemberList = this.groupList.allMembers;

		newMemberList.push(Member[0]);
		this.masterOrder.groupOrder.individualOrders = indOrders;
		this.groupList.allMembers = newMemberList;
		//pga: Feature-2920 setting submitted group bill number
		this.groupList.submittedGBN = orderInformation.groupOrder.groupBillNumber;
		this.headerInfo.members = newMemberList.length;
		this.calculateMemberCounts(
			newMemberList,
			orderInformation.groupOrder.individualOrders
		);
		this.getHeaderAmountDue();
		this.resortAllMembers();
	}

	//pga: Feature-2920 Properties for Recall and Apply payment functionality
	get getSubmittedMemberCount(): number {
		let count = 0;
		if (this.hasSubmittedStstus) {
			count = this.groupList.allMembers.filter((m: any) => m.status === this.statusCodeEnum.Submitted).length;
		}
		return count;
	}

	get hasSubmittedStstus(): boolean {
		return (this.groupList &&
			this.groupList.allMembers &&
			this.groupList.allMembers.length > 0 &&
			(
				//check if any member has 'submitted through' status
				this.groupList.allMembers.filter((m: any) => m.status === this.statusCodeEnum.Submitted).length > 0
				||
				//check if any member has status 'Processing Payment' and we have got the group bill number back (becasue in case of PO only we get the group bill number back)
				(
					this.groupList.allMembers.filter((m: any) => m.status === this.statusCodeEnum.Processing).length > 0
					&& this.groupList.submittedGBN != null
					&& this.groupList.submittedGBN != '')
			)
		);
	}

	get getOutStandingTotal(): number {
		let sum = 0;
		if (this.hasSubmittedStstus) {
			this.groupList.allMembers
				.filter((m: any) => m.status === this.statusCodeEnum.Submitted)
				.forEach((element: any) => {
					sum += element.amount;
				});
		}
		return sum;
	}

	get statusCodeEnum(): typeof statusCodesEnum {
		return statusCodesEnum;
	}
	//

	calculateMemberCounts(memberList, orderInformation = []) {
		let memberCounts = new MemberCounts();
		let selectedAmount = 0;
		let selectedMembers = [];
		memberCounts.paid = 0;
		memberCounts.submitted = 0;
		memberCounts.pending = 0;
		memberCounts.ready = 0;
		memberCounts.totalMembers = 0;
		this.showChart = true;
		this.chkAllMembers = false;
		this.enableChkAllMembers = false;
		this.enableProcessPayment = false;
		let cycleStartDate: Date;
		const d = new Date();
		const n = d.getMonth() + 1;

		if (this.groupList.GroupInfo.residencyDetail) {
			if (!this.inGroupBilling) {
				let expDate = "";
				if (n < 7) {
					expDate = "07/01/" + (d.getFullYear() - 1);
					cycleStartDate = new Date(expDate);
				} else {
					expDate = "07/01/" + d.getFullYear();
					cycleStartDate = new Date(expDate);
				}
			} else {
				cycleStartDate = new Date(this.groupList.GroupInfo.residencyDetail.cycleStartDate);
			}
		} else {
			cycleStartDate = new Date();
		}

		for (var i = 0; i < memberList.length; i++) {
			if (orderInformation.length > 0) {
				for (var o = 0; o < orderInformation.length; o++) {
					if (
						this.groupList.allMembers[i].contactNo ==
						orderInformation[o].individualNo &&
						!orderInformation[o].isSupplementalOrder
					) {
						this.groupList.allMembers[i].OrderLineItems =
							orderInformation[o].orderLineItems;
						this.groupList.allMembers[i].status =
							orderInformation[o].statusCode;
						this.groupList.allMembers[i].statusLabel =
							orderInformation[o].statusLabel;
						this.groupList.allMembers[i].memberRate = !this
							.groupList.GroupInfo.residencyDetail
							? orderInformation[o].memberRate
							: orderInformation[o].emraMemberRate;
						this.groupList.allMembers[i].memberType = !this
							.groupList.GroupInfo.residencyDetail
							? orderInformation[o].memberType
							: orderInformation[o].emraMemberType;
						this.groupList.allMembers[i].amount =
							orderInformation[o].totalAmount ? orderInformation[o].totalAmount : 0;
						break;
					}
				}
			}
			//pga: added condition hasSubmittedStstus to ignore calculation if order has submitted order
			if (
				this.groupList.allMembers[i].status === this.statusCodeEnum.ReadyForPayment &&
				!this.groupList.allMembers[i].hasOwnProperty["AddToOrder"]
				&& !this.hasSubmittedStstus
			) {
				this.chkAllMembers = true;
				this.enableChkAllMembers = true;
				this.enableProcessPayment = true;
				this.groupList.allMembers[i].AddToOrder = true;
				selectedAmount += this.groupList.allMembers[i].amount;
				selectedMembers.push(this.groupList.allMembers[i]);
				if (!this.groupList.GroupInfo.physgrpDetail) {
					this.setResidentGradYears(this.groupList.allMembers[i]);
				}
			}
			this.groupList.selectedMembers = selectedMembers;
			if (!this.hasSubmittedStstus) {
				this.groupList.selectedAmount = selectedAmount;
			} else {
				this.groupList.selectedAmount = this.getOutStandingTotal;
			}

			this.groupList.hasSubmittedStatus = this.hasSubmittedStstus;
			this.groupList.outstandingTotal = this.getOutStandingTotal;
			this.groupList.submittedMemberCount = this.getSubmittedMemberCount;
			this.sortByGradYear();
			this.sortResidentMembers();
			const memberEndDate = new Date(this.groupList.allMembers[i].endDate);
			if (
				!this.groupList.GroupInfo.residencyDetail ||
				memberEndDate >
				cycleStartDate
			) {



				memberCounts.totalMembers += 1;
				switch (this.groupList.allMembers[i].status) {
					case this.statusCodeEnum.NotInGroupBill: {
						memberCounts.notInGB += 1;
						break;
					}
					case this.statusCodeEnum.ReadyForPayment: {
						memberCounts.ready += 1;
						break;
					}
					case this.statusCodeEnum.Pending: {
						memberCounts.pending += 1;
						break;
					}
					case this.statusCodeEnum.Paid: {
						memberCounts.paid += 1;
						break;
					}
					case this.statusCodeEnum.Processing: {
						break;
					}
					//pga: Feature-2920 incresing submitted member count
					case this.statusCodeEnum.Submitted: {
						memberCounts.submitted += 1;
						break;
					}
					default: {


						this.groupList.allMembers[i].status = this.statusCodeEnum.NotInGroupBill;
						this.groupList.allMembers[i].statusLabel =
							"Not In Group Bill";

						memberCounts.notInGB += 1;
						break;
					}
				}
			}
		}
		this.getPieReady(memberCounts);
	}

	sortResidentMembers() {
		for (var i = 0; i < this.groupList.ResidentInvoiceData.length; i++) {
			var lastNameSortedMembers = this.sortByLastName(this.groupList.ResidentInvoiceData[i].yearMembers);
			this.groupList.ResidentInvoiceData[i].yearMembers = lastNameSortedMembers;
		}


	}

	sortByGradYear() {
		return this.groupList.ResidentInvoiceData.sort((a: any, b: any) =>
			a.gradYear < b.gradYear ? -1 : a.gradYear > b.gradYear ? 1 : 0
		);
	}

	setResidentGradYears(selectedMember) {
		var rid = this.groupList.ResidentInvoiceData;
		var varGradYear = selectedMember.gradYear;
		var addYear = true;

		for (var i = 0; i < this.groupList.ResidentInvoiceData.length; i++) {
			if (rid[i].gradYear === varGradYear) {
				addYear = false;
				rid[i].yearMembers.push(selectedMember);
				break;
			}
		}
		if (addYear) {
			var gradYearGroup = {
				gradYear: varGradYear,
				yearMembers: [selectedMember]
			}
			this.groupList.ResidentInvoiceData.push(gradYearGroup);
		}
	}

	getPieReady(objMbrCnt: MemberCounts) {
		//set the values of my pie values
		//(this.pieslicePaid + this.pieslicePending + this.piesliceReadyForPayment);
		//pga: Feature-2920 including submitted member in total count
		let totmem =
			objMbrCnt.ready +
			objMbrCnt.pending +
			objMbrCnt.paid +
			objMbrCnt.notInGB +
			objMbrCnt.submitted;

		objMbrCnt.percentofPieSliceReadyForPayment = Math.round(
			(objMbrCnt.ready / totmem) * 100
		);
		objMbrCnt.percentofPieSlicePending = Math.round(
			(objMbrCnt.pending / totmem) * 100
		);
		//pga: Feature-2920 calculating percent for paid including submitted
		objMbrCnt.percentofPieSlicePaid = Math.round(
			((objMbrCnt.paid + objMbrCnt.submitted) / totmem) * 100
		);
		objMbrCnt.percentofPieSliceNotInGB = Math.round(
			(objMbrCnt.notInGB / totmem) * 100
		);

		objMbrCnt.strokeoffsetReadyForPayment = 0; //fist one written
		objMbrCnt.strokeoffsetPending = -objMbrCnt.percentofPieSliceReadyForPayment;
		objMbrCnt.strokeoffsetPaid = -(
			objMbrCnt.percentofPieSliceReadyForPayment +
			objMbrCnt.percentofPieSlicePending
		);
		objMbrCnt.strokeoffsetNotInGB = -(
			objMbrCnt.percentofPieSliceReadyForPayment +
			objMbrCnt.percentofPieSlicePending +
			objMbrCnt.percentofPieSlicePaid
		);

		this.setMemberCounts(objMbrCnt);
		//this.dataContainer.nativeElement.innerHTML = this.myPieChart();
	}

	resortAllMembers() {
		switch (this.sortedBy) {
			case "subtotal": {
				this.changeSortSubtotal();
				break;
			}
			case "name": {
				this.changeSortName();
				break;
			}
			case "npi": {
				this.changeSortNPI();
				break;
			}
			case "status": {
				this.changeSortStatus();
				break;
			}
			default: {
				this.groupList.allMembers = this.initOrderMembers(
					this.groupList.allMembers
				);
				break;
			}
		}
	}

	searchForContact(searchText, isNPI = false, isLeadership = false, selectedContactDetails = null) {
		if (searchText === "" && !isNPI) {
			this.groupList.searchContactList = [];
			return false;
		} else {
			if (isNPI && searchText.length < 10) {
				return false;
			}
			return this.http
				.get(
					this.getSearchContactListURL +
					"count=100&pattern=" +
					searchText,
					{
						headers: new HttpHeaders({
							"x-silent": "true",
							"Content-Type": "application/json",
							Authorization: this.ssoService.toolkitauthencoded
						})
					}
				)
				.pipe(
					map((res: HttpResponse<any>) => {
						if (!isLeadership) {
							if (!isNPI) {
								this.setSearchContactList(res);
							} else {
								this.npiExists = this.contactsExists(res);
							}
						} else {
							this.setAddedLeadershipContact(selectedContactDetails, res);
							this.slideOutBlur();
						}
					}),
					share()
				)
				.subscribe();
		}
	}



	userExistsByEmail(searchText, currentAcepId) {
		if (searchText === "") {
			this.emailExists = false;
			return of(null);
		} else {
			return this.http
				.get(
					this.getSearchContactListURL +
					"count=100&pattern=" +
					searchText,
					{
						headers: new HttpHeaders({
							"x-silent": "true",
							"Content-Type": "application/json",
							Authorization: this.ssoService.toolkitauthencoded
						})
					}
				)
				.pipe(
					map((res: HttpResponse<any>) => {
						this.checkIfEmailExists(res, searchText, currentAcepId);
					})
				);
		}
	}

	SearchEmail(searchterms: Observable<string>): any {
		return searchterms.pipe(
			debounceTime(500),
			distinctUntilChanged(),
			switchMap(term =>
				this.userExistsByEmail(
					term,
					this.selectedContactDetails.value.ACEPID
				)
			)
		);
	}

	checkIfEmailExists(contacts, searchText, currentAcepId) {
		if (contacts.length > 0) {
			for (var i = 0; i < contacts.length; i++) {
				if (
					contacts[i].emailAddress1 == searchText &&
					contacts[i].acepId != currentAcepId
				) {
					this.emailExists = true;
				}
			}
		} else {
			this.emailExists = false;
		}
	}

	contactsExists(contacts) {
		if (contacts.length > 0) {
			return true;
		} else {
			return false;
		}
	}
	resetSearchContactList() {
		this.groupList.searchContactList = [];
	}
	setSearchContactList(contactList) {
		this.groupList.searchContactList = contactList;
	}

	getContactInfoAndSendEmail(acepId, isSempa = false) {
		let payload = {
			contactNumber: acepId,
			questionnaireid: "ACEP",
			questionnairemasterid: "contact,address,membership"
		};

		return this.http
			.post(this.getContactDetails, JSON.stringify(payload), {
				headers: new HttpHeaders({
					"Content-Type": "application/json",
					Authorization: this.ssoService.toolkitauthencoded
				})
			})
			.pipe(
				map((res: Response) => {
					this.sendUpdateMemberAppEmail(res, isSempa);
				}),
				share()
			)
			.subscribe();
	}

	getEditContactInfo(
		acepId,
		editContact = false,
		member?,
		updateMember = false
	) {
		let payload = {
			contactNumber: acepId,
			questionnaireid: "ACEP",
			questionnairemasterid: "contact,address,membership,education"
		};

		return this.http
			.post(this.getContactDetails, JSON.stringify(payload), {
				headers: new HttpHeaders({
					"Content-Type": "application/json",
					Authorization: this.ssoService.toolkitauthencoded
				})
			})
			.pipe(
				switchMap((res: Response) => {
					return this.getResidencyDetailsFromContact(acepId).pipe(
						map((residencyDetails) => {
							this.createContactDetailObject(
								res,
								residencyDetails,
								editContact,
								member,
								updateMember
							);
							this.resetSearchContactList();
						})
					);
				}),
				share()
			)
			.subscribe(
				() => {
					this.sideNavService.refreshResidency$.next(true);
				});
	}

	getResidencyDetailsFromContact(contactId) {
		return this.http
			.get(
				this.getGroupMembersURL +
				"/" +
				this.groupList.groupNumber +
				"/contacts/" +
				contactId,
				{
					headers: new HttpHeaders({
						"Content-Type": "application/json",
						Authorization: this.ssoService.toolkitauthencoded
					})
				}
			)
			.pipe(
				catchError((error: HttpErrorResponse) => {
					// Handle the error, you can log it or take appropriate action
					console.error("Error in getResidencyDetailsFromContact:", error);
					// Return an empty object or some default value to continue processing
					return of({});
				}),
				map((residencyDetails: HttpResponse<any>) => {
					return residencyDetails;
				}),
				share()
			);
	}

	setPaymentMethods(paymentResponse) {
		let paymentDetails = new paymentMethod();
		let paymentMethodList = [];
		if (paymentResponse.length > 0) {
			for (var i = 0; i < paymentResponse.length; i++) {
				var dateobj = new Date(paymentResponse[i].ccExpirationDate);
				var today = new Date();
				// paymentDetails.nameOnCard = paymentResponse[i].nameOnCard;
				// paymentDetails.creditCardNumber =
				// 	paymentResponse[i].creditCardNumber;
				// paymentDetails.ccExpirationDate =
				// 	paymentResponse[i].ccExpirationDate;
				paymentResponse[i].ccShortDate =
					dateobj.getMonth() + 1 + "/" + dateobj.getFullYear();
				paymentResponse[i].cardExpired = dateobj < today;
				paymentResponse[i].cardType = this.getCardName(
					paymentResponse[i].cardType
				);
				paymentMethodList.push(paymentResponse[i]);
			}
			this.showPayMethods = true;
		} else {
			this.showPayMethods = false;
		}
		this.groupList.paymentTypes = paymentMethodList;
		this.paymentMethodDoneProcessing = true;
	}

	getCardName(cardType) {
		let cardName = "";
		switch (cardType) {
			case 1: {
				cardName = "AmericanExpress";
				break;
			}
			case 2: {
				cardName = "MasterCard";
				break;
			}
			case 3: {
				cardName = "Visa";
				break;
			}
			case 4: {
				cardName = "Discover";
				break;
			}
		}
		return cardName;
	}

	initializeHeaderInfo(groupResponse) {
		this.headerInfo.groupName = groupResponse.name;
		this.headerInfo.groupId = groupResponse.accountNo;
		let dueDate = this.groupList.GroupInfo.residencyDetail && this.groupList.GroupInfo.residencyDetail.dueDate
			? this.groupList.GroupInfo.residencyDetail.dueDate
			: this.groupList.GroupInfo.physgrpDetail
				? this.groupList.GroupInfo.physgrpDetail.dueDate
				: "";
		this.headerInfo.dueDate = dueDate
			? this.SantizeDate(dueDate.toString())
			: "N/A";
	}

	createContactDetailObject(
		contact,
		residencyDetails,
		editContact,
		member,
		updateMember = false
	) {
		let contactDetails = new AcepContact();
		let contactAddresses = [];
		if (contact.contact.length > 0) {
			contactDetails.ACEPID = contact.contact[0].contactNumber;
			contactDetails.FirstName = contact.contact[0].firstName;
			contactDetails.MiddleName = contact.contact[0].middleName;
			contactDetails.LastName = contact.contact[0].lastName;
			contactDetails.NPINumber = contact.contact[0].npi;
			contactDetails.EmailAddress = contact.contact[0].email.replace(" ", "");
			contactDetails.Phone = contact.contact[0].phone;
			contactDetails.prefix = contact.contact[0].prefix;
			contactDetails.jobTitle = contact.contact[0].jobTitle;

		}

		//residency details
		if (residencyDetails.length > 0) {
			contactDetails.residency.id = residencyDetails[0].residencyId;
			contactDetails.residency.specialityId = residencyDetails[0].residencySpecialtyId;
			contactDetails.residency.gradYear = residencyDetails[0].gradYear.toString();
		}

		//primary chapter
		if (contact.chapters?.length > 0) {

			let ch_name = contact.chapters?.find(c => c.primaryChapter == true)?.chapterAccountName;
			if (!!ch_name) {
				contactDetails.Chapter = this.dataService.uidata.Chapters.find(c => c.name == ch_name).acep_code;
			}
		}

		//medical License
		if (contact.credentials?.length > 0) {
			contactDetails.MedicalLicense = contact.credentials.find(a => a.credentialType == "MedicalLicense");
		}

		//membership
		if (contact.membership?.length > 0) {
			contactDetails.Membership = contact.membership[0];
		}

		//Addresses
		if (contact.address.length > 0) {
			//contact.address = contact.address.filter(a => a.addressType != "Hospital");
			for (var i = 0; i < contact.address.length; i++) {
				if (contact.address[i].primaryAddress) {
					contactDetails = this.setSelectedContactDetailsAddress(
						contact.address[i],
						contactDetails
					);
				}
				contactAddresses.push(contact.address[i]);
			}
		} else {
			contactDetails.Country = "";
		}

		if (editContact) {
			//  let startDate = member.beginDate ? member.beginDate : '';
			//  let endDate = member.endDate != null ? member.endDate : '';
			contactDetails.startDate = member.beginDate;
			contactDetails.endDate = member.endDate;
			contactDetails.groupBilling = member.isInGroupBilling;
		} else {
			contactDetails.startDate = "";
			contactDetails.endDate = "";
			contactDetails.groupBilling = true;
		}

		//this.refreshStateProvinces(contactDetails.Country);
		if (contactAddresses.length > 0) {
			this.setEditContactAddresses(contactAddresses);
		}
		this.setEditContactInfo(contactDetails);
		if (updateMember) {
			this.updateGroupMember(contactDetails);
		}
	}

	sendUpdateMemberAppEmail(contact, isSempa) {
		if (contact.contact.length > 0) {
			this.emailHelperService.sendNewGroupMemberEmail(
				contact.contact[0].email,
				this.headerInfo.groupName,
				isSempa
			);
		}
	}

	setSelectedContactDetailsAddress(
		contactAddress,
		contactDetails: AcepContact,
		newAddressType = false
	) {
		let addressType = 1;
		if (!newAddressType) {
			switch (contactAddress.addressType) {
				case "Home": {
					addressType = 1;
					break;
				}
				case "Hospital": {
					addressType = 2;
					break;
				}
				case "Business": {
					addressType = 3;
					break;
				}
				default: {
					addressType = 1;
				}
			}
			contactDetails.AddressType = addressType;
			contactDetails.AddressAttention = contactAddress.addressLine3;
			contactDetails.Country = contactAddress.country;
			contactDetails.Street = contactAddress.addressLine1;
			contactDetails.Apt = contactAddress.addressLine2;
			contactDetails.City = contactAddress.city;
			contactDetails.State = contactAddress.stateOrProvince;
			contactDetails.Zip = contactAddress.postalCode;
		} else {
			contactDetails.AddressAttention = "";
			contactDetails.Country = "US";
			contactDetails.Street = "";
			contactDetails.City = "";
			contactDetails.State = "";
			contactDetails.Zip = "";
		}

		return contactDetails;
	}

	// refreshStateProvinces(country) {
	// this.dataService.uidata.StateProvinces = this.dataService.uidata.StateProvinces.filter(
	//   s => s.countrycode === country
	// );
	//}

	setPaymentTypes(paymentMethods) {
		this.paymentTypes.next(paymentMethods);
	}
	setEditContactInfo(contact) {
		this.selectedContactDetails.next(contact);
	}

	setEditContactAddresses(addresses) {
		this.selectedContactAddresses.next(addresses);
	}

	setMemberCounts(memberCounts) {
		this.gpdsMemberCounts = memberCounts;
	}

	setHeaderAmount(totalAmount) {
		this.headerInfo.amountDue = totalAmount;
	}

	setHeaderMemberCount(memberNumber) {
		this.headerInfo.members = memberNumber;
	}

	setHeaderDueDate(headerDueDate) {
		this.headerInfo.dueDate = headerDueDate;
	}

	sendGroupInfo(groupResponse) {
		this.groupList.GroupInfo = groupResponse;
		this.groupList.FormGroupInfo = JSON.parse(JSON.stringify(groupResponse));

		if (this.groupList.GroupInfo && this.groupList.GroupInfo.residencyDetail) {
			this.setSpecialty();
			this.inGroupBilling = this.groupList.GroupInfo.residencyDetail.inGroupBilling === 'Yes' ? true : false;
			this.groupList.GroupInfo.residencyDetail.programLength = this.groupList.GroupInfo.residencyDetail.programLength?.toString();
			this.groupList.FormGroupInfo.residencyDetail.programLength = this.groupList.GroupInfo.residencyDetail.programLength?.toString();

		} else if (this.groupList.GroupInfo && this.groupList.GroupInfo.physgrpDetail) {
			this.inGroupBilling = this.groupList.GroupInfo.physgrpDetail.inGroupBilling === 'Yes' ? true : false;
		}
		this.setNewContact();
		this.setAreasToShow();
		this.refreshStateProvinces();
		this.showGroupInfo = true;
		this.groupInfoDoneProcessing = true;
		this.groupList.Director = this.findObjectLikeByKey(
			groupResponse.groupContacts,
			"position",
			"Director"
		);
		this.groupList.Coordinator = this.findObjectLikeByKey(
			groupResponse.groupContacts,
			"position",
			"Coordinator"
		);
		this.groupList.Administrator = this.findAdminByKey(
			groupResponse.groupContacts,
			"position",
			"Group Administrator"
		);
	}

	setSpecialty() {
		this.specialty = '';

		if (this.groupList.GroupInfo && this.groupList.GroupInfo
			.residencyDetail.isSpecialtyEM) {
			this.specialty = 'EME';
		}
		if (this.groupList.GroupInfo && this.groupList.GroupInfo
			.residencyDetail.isSpecialtyFM) {
			if (this.specialty !== '') {
				this.specialty += ',';
			}
			this.specialty += 'EM/FM';
		}
		if (this.groupList.GroupInfo && this.groupList.GroupInfo
			.residencyDetail.isSpecialtyIM) {
			if (this.specialty !== '') {
				this.specialty += ',';
			}
			this.specialty += 'EM/IM';
		}
		if (this.groupList.GroupInfo && this.groupList.GroupInfo
			.residencyDetail.isSpecialtyPD) {
			if (this.specialty !== '') {
				this.specialty += ',';
			}
			this.specialty += 'EM/Peds';
		}
		if (this.groupList.GroupInfo && this.groupList.GroupInfo
			.residencyDetail.isSpecialtyCC) {
			if (this.specialty !== '') {
				this.specialty += ',';
			}
			this.specialty += 'EM/IM/CC';
		}
		if (this.groupList.GroupInfo && this.groupList.GroupInfo
			.residencyDetail.isSpecialtyAnesthesia) {
			if (this.specialty !== '') {
				this.specialty += ',';
			}
			this.specialty += 'EM/Anesthesia';
		}
	}
	setGroupListAllMembers(groupMembers, orderInformation) {
		if (this.groupList.allMembers.length < 1) {
			this.masterOrder = orderInformation;
			this.groupList.allMembers = groupMembers;
			this.groupList.submittedGBN = orderInformation.groupOrder.groupBillNumber;
			this.calculateMemberCounts(
				this.groupList.allMembers,
				orderInformation.groupOrder.individualOrders
			);
			this.groupList.allMembers = this.initOrderMembers(
				this.groupList.allMembers
			);
			this.headerInfo.members = this.groupList.allMembers.length;
			this.getHeaderAmountDue();
		}
	}

	initOrderMembers(groupMembers) {
		let members;
		let membersNotReady;
		let cycleStartDate: Date;
		const d = new Date();
		const n = d.getMonth() + 1;

		if (this.groupList.GroupInfo.residencyDetail) {
			if (!this.inGroupBilling) {
				let expDate = "";
				if (n < 7) {
					expDate = "07/01/" + (d.getFullYear() - 1);
					cycleStartDate = new Date(expDate);
				} else {
					expDate = "07/01/" + d.getFullYear();
					cycleStartDate = new Date(expDate);
				}
			} else {
				cycleStartDate = new Date(this.groupList.GroupInfo.residencyDetail.cycleStartDate);
			}
		} else {
			cycleStartDate = new Date();
		}

		members = this.sortByLastName(groupMembers.filter(a => a.status === this.statusCodeEnum.ReadyForPayment));
		membersNotReady = this.sortByLastName(
			groupMembers.filter(a => a.status !== this.statusCodeEnum.ReadyForPayment)
		);
		for (var i = 0; i < membersNotReady.length; i++) {
			const memberEndDate = new Date(membersNotReady[i].endDate);
			if (
				!this.groupList.GroupInfo.residencyDetail ||
				memberEndDate >
				cycleStartDate
			) {
				members.push(membersNotReady[i]);
			}
		}
		return this.getResidentMembers(members);
	}

	sortByLastName(groupmembers) {
		return groupmembers.sort((a: any, b: any) =>
			a.lastName < b.lastName ? -1 : a.lastName > b.lastName ? 1 : 0
		);
	}

	getResidentMembers(groupmembers) {
		let members = [];
		for (var i = 0; i < groupmembers.length; i++) {
			if (groupmembers[i].position != "Intern") {
				members.push(groupmembers[i]);
			}
		}
		return members;
	}

	getHeaderAmountDue() {
		let total = 0;
		for (let i = 0; i < this.groupList.allMembers.length; i++) {
			let member = this.groupList.allMembers[i];
			total += member.amount;
		}
		this.headerInfo.amountDue = total;
	}

	getSelectedGroup(): Observable<Group> {
		return this.selectedGroup.asObservable();
	}

	getSelectedContactDetails(): Observable<AcepContact> {
		return this.selectedContactDetails.asObservable();
	}

	getSelectedContactAddresses(): Observable<any[]> {
		return this.selectedContactAddresses.asObservable();
	}
	// getMemberCounts(): Observable<MemberCounts> {
	// 	return this.gpdsMemberCounts.asObservable();
	// }

	getGroupNumber(): Observable<String> {
		return this.groupNumber.asObservable();
	}

	getGroupInfo(): Observable<any> {
		return this.GroupInfo.asObservable();
	}

	getAllMembers(): Observable<any> {
		return this.allMembers.asObservable();
	}

	findObjectByKey(array, key, value) {
		for (var i = 0; i < array.length; i++) {
			if (array[i][key] === value) {
				return array[i];
			}
		}
		return null;
	}

	findAdminByKey(array, key, value) {
		var isStaff = false;
		for (var i = 0; i < array.length; i++) {
			if (array[i][key] === "Group Administrator Staff") {
				if (this.ssoService.acepid == array[i]["contactNo"]) {
					isStaff = true;
					break;
				}
			}
		}

		for (var x = 0; x < array.length; x++) {
			if (array[x][key] === value) {
				if (
					this.ssoService.acepid == array[x]["contactNo"] ||
					isStaff
				) {
					return array[x];
				}
			}
		}
		return null;
	}

	findCountryIndex(array, key, value) {
		for (var i = 0; i < array.length; i++) {
			if (array[i].label === value) {
				return array[i].value;
			}
		}
		return null;
	}

	findObjectLikeByKey(array, key, value) {
		for (var i = 0; i < array.length; i++) {
			let string = array[i][key];
			if (string.indexOf(value) !== -1) {
				return array[i];
			}
		}
		return null;
	}

	ResetGroupPortalData() {
		this.memberAppData = null;
		this.globalDomOpsService.showwait();
	}

	notify(status: NotificationStatus) {
		this.memberAppData.notifyInfo.status = status;
		this.navigateToRoute("notify");
	}

	navigateToRoute(routename, reroute = true, accountId = "") {
		this.scrollToTop();
		$("ul li.active.route").removeClass("active route");
		$("ul li button#" + routename)
			.parent()
			.addClass("active route");
		routename = routename + "/" + accountId;
		if (reroute) {
			this.router.navigate([routename]);
		}
	}

	scrollToTop() {
		$("html,body").animate(
			{
				scrollTop: $(".gpTop").offset().top
			},
			"medium"
		);
	}

	changeSortSubtotal() {
		if (this.sortSubtotalAscending) {
			this.groupList.allMembers = this.groupList.allMembers.sort(
				(a: any, b: any) =>
					a.amount < b.amount ? -1 : a.amount > b.amount ? 1 : 0
			);
		} else {
			this.groupList.allMembers = this.groupList.allMembers.sort(
				(a: any, b: any) =>
					a.amount > b.amount ? -1 : a.amount < b.amount ? 1 : 0
			);
		}
	}

	changeSortName() {
		if (this.sortNameAscending) {
			this.groupList.allMembers = this.groupList.allMembers.sort(
				(a: any, b: any) =>
					a.lastName < b.lastName
						? -1
						: a.lastName > b.lastName
							? 1
							: 0
			);
		} else {
			this.groupList.allMembers = this.groupList.allMembers.sort(
				(a: any, b: any) =>
					a.lastName > b.lastName
						? -1
						: a.lastName < b.lastName
							? 1
							: 0
			);
		}
	}

	changeSortNPI() {
		if (this.sortNPIAscending) {
			this.groupList.allMembers = this.groupList.allMembers.sort(
				(a: any, b: any) => (a.npi < b.npi ? -1 : a.npi > b.npi ? 1 : 0)
			);
		} else {
			this.groupList.allMembers = this.groupList.allMembers.sort(
				(a: any, b: any) => (a.npi > b.npi ? -1 : a.npi < b.npi ? 1 : 0)
			);
		}
	}

	changeSortStatus() {
		if (this.sortStatusAscending) {
			this.groupList.allMembers = this.groupList.allMembers.sort(
				(a: any, b: any) =>
					a.status < b.status ? -1 : a.status > b.status ? 1 : 0
			);
		} else {
			this.groupList.allMembers = this.groupList.allMembers.sort(
				(a: any, b: any) =>
					a.status > b.status ? -1 : a.status < b.status ? 1 : 0
			);
		}
	}

	changeSortInvoiceDate() {
		if (this.sortInvoiceDateAscending) {
			this.groupList.groupInvoices = this.groupList.groupInvoices.sort(
				(a: any, b: any) =>
					new Date(a.date) < new Date(b.date)
						? -1
						: new Date(a.date) > new Date(b.date)
							? 1
							: 0
			);
		} else {
			this.groupList.groupInvoices = this.groupList.groupInvoices.sort(
				(a: any, b: any) =>
					new Date(a.date) > new Date(b.date)
						? -1
						: new Date(a.date) < new Date(b.date)
							? 1
							: 0
			);
		}
	}

	changeSortInvoiceGBNumber() {
		if (this.sortGBNumberAscending) {
			this.groupList.groupInvoices = this.groupList.groupInvoices.sort(
				(a: any, b: any) =>
					a.groupBillNumber < b.groupBillNumber
						? -1
						: a.groupBillNumber > b.groupBillNumber
							? 1
							: 0
			);
		} else {
			this.groupList.groupInvoices = this.groupList.groupInvoices.sort(
				(a: any, b: any) =>
					a.groupBillNumber > b.groupBillNumber
						? -1
						: a.groupBillNumber < b.groupBillNumber
							? 1
							: 0
			);
		}
	}

	changeSortInvoiceStatus() {
		if (this.sortInvoiceStatusAscending) {
			this.groupList.groupInvoices = this.groupList.groupInvoices.sort(
				(a: any, b: any) =>
					a.status < b.status ? -1 : a.status > b.status ? 1 : 0
			);
		} else {
			this.groupList.groupInvoices = this.groupList.groupInvoices.sort(
				(a: any, b: any) =>
					a.status > b.status ? -1 : a.status < b.status ? 1 : 0
			);
		}
	}

	changeSortInvoiceAmount() {
		if (this.sortInvoiceAmountAscending) {
			this.groupList.groupInvoices = this.groupList.groupInvoices.sort(
				(a: any, b: any) =>
					a.amount < b.amount ? -1 : a.amount > b.amount ? 1 : 0
			);
		} else {
			this.groupList.groupInvoices = this.groupList.groupInvoices.sort(
				(a: any, b: any) =>
					a.amount > b.amount ? -1 : a.amount < b.amount ? 1 : 0
			);
		}
	}

	slideOutBlur() {
		this.slideOutShown = false;
		this.scrollToTop();
		$("nav#sidebar").attr(
			"style",
			"position:relative; animation: animateright 0.4s; margin-left:-100vw; "
		);
		$("#GPsidenav ul li.active.slideOutShow").removeClass(
			"active slideOutShow"
		);
		this.SideNavDisplay("close");
	}

	SideNavDisplay(openorclose) {
		if (openorclose == "open") {
			document.getElementById("mySidepanel").style.visibility = "visible";
			document.getElementById("mySidepanel").style.width = "40vw";
			document.getElementById("mySidepanel").style.height = "100vh";
		} else {
			document.getElementById("mySidepanel").style.width = "0";
			document.getElementById("mySidepanel").style.visibility = "hidden";
		}
	}

	public SantizeDate(date: string): string {
		if (date == "" || date == null) return "";
		return moment(date).format("MM/DD/YYYY");
	}

	private handleError(error: Response | any) {
		let errMsg: string;
		if (error instanceof Response) {
			const body = error || "";
			const err = error || JSON.stringify(body);
			errMsg = error["_body"];
		} else {
			errMsg = error._body ? error._body : error.toString();
		}
		console.error(errMsg);
		return Observable.throw(errMsg);
	}
}
